<div class="row" *ngIf="loading">
  <div class="loader">Loading...</div>
</div>

<div class="row mb-3" *ngIf="loaded">
  <div class="col-12 text-right align-self-center">
    <button class="btn btn-default mr-2" (click)="back()">Back</button>
    <button class="btn btn-primary" (click)="save()">Save</button>
  </div>
</div>

<div class="card" *ngIf="loaded">
  <div class="card-header lead font-weight-bold">
    Affiliate Detail
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <small><i class="text-danger">* indicates mandatory field</i></small>
      </div>
      <div class="col-5">
        <dt class="col-sm-12">
          <span class="badge badge-pill badge-primary bg-gradient">General</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right">Created At :</dt>
          <dd class="col-sm-8">{{affiliate.createdAt | date}}</dd>
          <dt class="col-sm-4 text-right">Short Code :</dt>
          <dd class="col-sm-8">{{affiliate.shortCode}}</dd>
          <dt class="col-sm-4 text-right">Keyword :</dt>
          <dd class="col-sm-8">{{affiliate.keyword}}</dd>
          <dt class="col-sm-4 text-right">Affiliate :</dt>
          <dd class="col-sm-8">{{affiliate.affiliate}}</dd>
          <dt class="col-sm-4 text-right">Operator :</dt>
          <dd class="col-sm-8">{{affiliate.operator}}</dd>
          <dt class="col-sm-4 text-right align-self-center">Client :</dt>
          <dd class="col-sm-8">
            <select class="form-control" placeholder="Select" [(ngModel)]="affiliate.managerId" placeholder="select">
              <option value=null selected>- select client -</option>
              <option *ngFor="let client of clientList" [value]="client.id">{{client.username}}</option>
            </select>
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Share :</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="affiliate.share" class="form-control" placeholder="Share">
          </dd>
        </dl>
        <dt class="col-sm-12">
          <span class="badge badge-pill badge-primary bg-gradient">Postback Rate</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center">Mo Postback Rate:</dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="affiliate.moPostBackRate" class="form-control" placeholder="100" min="0" max="100">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Dn Postback Rate:</dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="affiliate.dnPostBackRate" class="form-control" placeholder="100" min="0" max="100">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Conversion Postback Rate :</dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="affiliate.cnvPostBackRate" class="form-control" placeholder="100" min="0" max="100">
          </dd>
        </dl>
      </div>
      <div class="col-7">
        <dt class="col-sm-12">
          <span class="badge badge-pill badge-primary bg-gradient">Postback Min</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center">Mo Postback Min:</dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="affiliate.moMin" class="form-control" placeholder="0">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Dn Postback Min:</dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="affiliate.dnMin" class="form-control" placeholder="0">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Conversion Postback Min :</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="affiliate.cnvMin" class="form-control" placeholder="0">
          </dd>
        </dl>
        <dt class="col-sm-12">
          <span class="badge badge-pill badge-primary bg-gradient">Postback Cap</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center">Mo Postback Cap:</dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="affiliate.moCap" class="form-control" placeholder="0">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Dn Postback Cap:</dt>
          <dd class="col-sm-8">
            <input type="number" [(ngModel)]="affiliate.dnCap" class="form-control" placeholder="0">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Conversion Postback Cap :</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="affiliate.cnvCap" class="form-control" placeholder="0">
          </dd>
        </dl>
        <dt class="col-sm-12">
          <span class="badge badge-pill badge-primary bg-gradient">Postback URL</span>
        </dt>
        <dl class="row">
          <dt class="col-sm-4 text-right align-self-center">Mo Postback URL:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="affiliate.moNotifyUrl" class="form-control" placeholder="mo notify url">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Dn Postback URL:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="affiliate.dnNotifyUrl" class="form-control" placeholder="dn notify url">
          </dd>
          <dt class="col-sm-4 text-right align-self-center">Conversion Postback URL:</dt>
          <dd class="col-sm-8">
            <input type="text" [(ngModel)]="affiliate.cnvUrl" class="form-control" placeholder="cnv url">
          </dd>
        </dl>
      </div>
    </div>

  </div>
</div>
